// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "" + ({"41":"mocks-list","387":"msw"}[chunkId] || chunkId) + "." + {"41":"721457a1c8b6ce9e196b","277":"85e737eb9a3aa5f19f5c","387":"e4dfdd16742c32175f03","396":"5011269fff18696aecdb","424":"567158759037e593bf2b","678":"d18e8563d62464ad2aca"}[chunkId] + ".js";
};